module.exports = __webpack_public_path__ + "img/Comic.df2f3571.svg";